// Audit Logs translations for React Admin resource
export const auditLogsResource = {
  name: 'Audit Logs',
  fields: {
    id: 'ID',
    createdAt: 'Time',
    action: 'Action',
    user: 'User',
    userId: 'User ID',
    resource: 'Resource',
    resourceType: 'Resource',
    resourceId: 'Resource ID',
    details: 'Details',
    additionalInfo: 'Additional Information',
    fullDetails: 'Full Details',
    ipAddress: 'IP Address',
    userAgent: 'User Agent',
    startDate: 'Start Date',
    endDate: 'End Date',
  },
};

// Custom audit logs translations for components
export const auditLogs = {
  list: {
    title: 'Audit Logs',
    filters: {
      search: 'Search',
      action: 'Action',
      userId: 'User ID',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
  },
  actions: {
    'auth.login': 'Login',
    'auth.login.failed': 'Failed Login',
    'auth.logout': 'Logout',
    'auth.2fa.enable': '2FA Enabled',
    'auth.2fa.disable': '2FA Disabled',
    'auth.2fa.admin.disable': 'Admin Disabled User 2FA',
    'user.create': 'User Created',
    'user.update': 'User Updated',
    'user.delete': 'User Deleted',
    'user.preferences.update': 'Preferences Updated',
    'role.create': 'Role Created',
    'role.update': 'Role Updated',
    'role.delete': 'Role Deleted',
    'permission.assign': 'Permission Assigned',
    'settings.update': 'Settings Updated',
    'settings.logo.upload': 'Logo Uploaded',
    'settings.logo.delete': 'Logo Deleted',
    'update_app_user': 'App User Updated',
    'logout': 'Logged Out',
    'login': 'Logged In',
    // Legacy format (with colons)
    'auth:login': 'Logged in',
    'auth:logout': 'Logged out',
    'auth:failed': 'Failed login attempt',
    'user:create': 'User Created',
    'user:update': 'User Updated',
    'user:delete': 'User Deleted',
    'user:preferences:update': 'Preferences Updated',
    'role:create': 'Role Created',
    'role:update': 'Role Updated',
    'role:delete': 'Role Deleted',
    'permission:assign': 'Permission Assigned',
    'settings:update': 'Settings Updated',
    'settings:logo:upload': 'Logo Uploaded',
    'settings:logo:delete': 'Logo Deleted',
  },
  details: {
    reason: 'Reason',
    invalidCredentials: 'Invalid credentials',
    changes: {
      single: '1 field changed',
      multiple: '{count} fields changed',
    },
    noDetails: '—',
  },
  userAgent: {
    browser: {
      chrome: 'Chrome',
      firefox: 'Firefox',
      safari: 'Safari',
      edge: 'Edge',
      unknown: 'Unknown',
    },
    os: {
      windows: 'Windows',
      macos: 'macOS',
      linux: 'Linux',
      android: 'Android',
      ios: 'iOS',
      unknown: 'Unknown',
    },
  },
  user: {
    system: 'System',
  },
  empty: {
    title: 'No audit logs found',
    subtitle: 'Audit logs will appear here once there are user activities.',
  },
  stats: {
    title: 'Audit Statistics',
    totalActions: 'Total Actions',
    uniqueUsers: 'Unique Users',
    todayActions: "Today's Actions",
    weekActions: "This Week's Actions",
  },
};